// extracted by mini-css-extract-plugin
export default {"wrapper":"zy-z","viewport":"Ay-z","container":"By-z","slide":"Cy-z"};